import loadable from '@loadable/component';
import track from 'react-tracking';
import NewsListing from '@/components/NewsListing';
import type { NewsItem } from '@/components/NewsListing/redux/interface';
import ReportSection from '@/components/ReportSection';
import ReportSubSection from '@/components/ReportSubSection';
import ReportSectionHeader from '@/components/ReportSectionHeader';
import {
  PORTFOLIO_STATIC_COMPANY,
  PORTFOLIO_NEWS,
} from '@/constants/feedbackSections';

const ChartActionsContainer = loadable(
  () => import('@/components/ChartActions'),
  {
    ssr: false,
    resolveComponent: (component) => component.ChartActionsContainer,
  }
);

export interface NewsProps {
  listing: NewsItem[];
  sectionNumber: number;
}

const News = ({
  listing,
  sectionNumber,
  tracking: { trackEvent },
}: NewsProps & Tracking) => (
  <ReportSection sectionNumber={sectionNumber}>
    <ReportSectionHeader
      title="News"
      sectionDescription="The latest Simply Wall St News coverage"
    />
    <ReportSubSection
      title="Simply Wall St News"
      body={
        <>
          <NewsListing
            data={listing}
            handleNavigationToURL={(url: string, index: number) =>
              trackEvent({
                action: 'click',
                url: url,
                listIndex: index,
              })
            }
          />
          <ChartActionsContainer
            companyName={PORTFOLIO_STATIC_COMPANY}
            feedbackLabel={PORTFOLIO_NEWS}
          />
        </>
      }
    />
  </ReportSection>
);

export default track({
  type: 'track',
  subject: 'news',
})(News);
